import { Component } from '@angular/core';
import { AppConfigService } from '../../services/core/appConfig.service';

@Component({
  selector: 'app-redirect-logout',
  standalone: true,
  imports: [],
  templateUrl: './redirect-logout.component.html',
  styleUrl: './redirect-logout.component.css'
})
export class RedirectLogoutComponent  {

  constructor(private readonly configService: AppConfigService) {

  }

  ngOnInit(): void {
    // Al cerrar la sesíon de keycloack, forzamos esta vista para que internamente redirija a la url de uoc por defecto.
    globalThis.location.href = this.configService.apiUrlFront;
  }

}
